(function (factory) {
    typeof define === 'function' && define.amd ? define(factory) :
    factory();
}(function () { 'use strict';

    const $ = window.jQuery;

    /**
     * Init
     */

    function initElementorPopups() {
        closeGatedPopupsOnSubmit();
        ignorePopupsOnSpecificPages();
        disableScrollbarsOnPopups();
    }

    /*
     * Functions
     */

    function disableScrollbarsOnPopups() {
        if (window.location.search.includes("popup=off")) {
            return;
        }

        const className = "cant-scroll";

        $(document).on('elementor/popup/show', (event, popupId) => {
            const popup = document.querySelector(`div[data-elementor-id="${popupId}"]`);
            const settings = JSON.parse(popup.dataset.elementorSettings);
            if (settings['prevent_scroll'] === 'yes') {
                $("html,body").addClass(className);
            }
        });

        $(document).on('elementor/popup/hide', () => {
            $("html,body").removeClass(className);
        });
    }

    function ignorePopupsOnSpecificPages() {
        if (!window.location.search.includes("popup=off")) {
            return;
        }

        $("html,body").addClass('ignore-popups');
    }

    function closeGatedPopupsOnSubmit() {
        if (!document.body.className.includes('single-gated')) {
            return;
        }

        window.addEventListener('message', event => {
            if (document.body.className.includes('dialog-lightbox-body')) {
                if (event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormSubmit') {
                    document.querySelector('.dialog-close-button').click();
                }
            }
        });
    }

    function initAnimations() {
        setTimeout(() => {

            if (!body.classList.contains('single-page')) {
                return;
            }

            const root_classes = ['body(.single-page) .entry-content > *'];
            const child_classes = ['.cta_block__header', '.cta_block__content', '.cta_block__action',
                '.resources__header-heading', '.resources__content', '.resources__footer',
                '.accordion-block__title', '.accordion-block__heading', '.accordion-block__content'
            ];

            root_classes.forEach((rootClassName) => {
                document.querySelectorAll(rootClassName).forEach(el => {

                    if (el.classList.contains('accordion') ||
                        el.classList.contains('use_cases_hero') ||
                        el.classList.contains('form_content_columns') ||
                        el.classList.contains('animation--none')) {
                        return;
                    }

                    el.classList.add('root-animation');
                    child_classes.forEach((i) => {
                        el.querySelectorAll(i).forEach((f) => f.classList.add('inner-animation'));
                    });
                });
            });

            document.querySelectorAll('.root-animation')
                .forEach((root) => {
                    basicScroll.create({
                        elem: root,
                        from: 'top-bottom',
                        to: 'top-middle',
                        direct: true,
                        timing: 'circInOut',
                        props: {
                            '--root--fade': {
                                from: 0,
                                to: 1
                            },
                            // '--root--scroll': {
                            //     from: 3,
                            //     to: 0
                            // },
                        }
                    }).start();

                    basicScroll.create({
                        elem: root,
                        from: 'middle-top',
                        to: 'bottom-top',
                        direct: true,
                        timing: 'circInOut',
                        props: {
                            '--root--scroll': {
                                from: 0,
                                to: -3
                            },
                            // '--root--fade-out': {
                            //     from: 1,
                            //     to: 0.25
                            // }
                        }
                    }).start();

                    root.querySelectorAll('.inner-animation').forEach((child, index) => {
                        basicScroll.create({
                            elem: child,
                            from: 'top-middle',
                            to: 'middle-top',
                            direct: true,
                            timing: 'circInOut',
                            props: {
                                // '--child--fade': {
                                //     from: 0,
                                //     to: 1
                                // },
                                '--child--scroll-top': {
                                    from: 0,
                                    // to: (index + 1) * -1.5 + index * .25
                                    to: -1.5
                                },
                            }
                        }).start();
                    });
                });

        }, 1500);

        const header = document.querySelector('.header');
        if (header) {
            header.classList.add('ready');
        }

        const body = document.querySelector('body');
        if (body) {
            body.classList.add('ready');
        }

    }

    // Source: https://velotix-patternlab.paas.devdevdev.life/js/forms.js

    function initForms($) {

        window.addEventListener('message', event => {
            if (event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormReady') {
                $('.hs-form-' + event.data.id).each(function () {
                    markFieldsAsFilled($(this));
                    setupEvents(this, '.hs-form-field');
                });
            }
        });

        $('.form').each(function () {
            markFieldsAsFilled($(this));
            setupEvents(this);
        });

        window.markFieldsAsFilled = markFieldsAsFilled;

        /**
         * Functions
         */

        function setupEvents(element, selector = '.form__field') {
            const formFields = element.querySelectorAll(selector);
            formFields.forEach((formField) => {
                let input = formField.querySelector('input');

                if (!input) {
                    input = formField.querySelector('textarea');
                }

                if (!input) {
                    return;
                }

                const label = formField;

                input.addEventListener('focus', () => {
                    label.classList.add('active');
                });

                input.addEventListener('blur', () => {
                    label.classList.remove('active');
                });

                input.addEventListener('change', () => {
                    label.classList.toggle('filled', !!input.value);
                });
            });
        }

        function markFieldsAsFilled($form) {
            $form.find('input, textarea')
                .each((index, input) => {
                    setTimeout(() => {
                        if (!input.value) {
                            return;
                        }

                        const formField = input.parentNode;
                        formField.classList.add('filled');

                        // Hubspot
                        const formFieldParent = formField.parentNode;
                        if (formFieldParent) {
                            formFieldParent.classList.add('filled');
                        }
                    }, 200);
                });
        }

    }

    // Source: https://velotix-patternlab.paas.devdevdev.life/js/modals.js

    function initModals($) {

        /*
         * Modal Class
         */

        class Modal {

            constructor(target) {
                this.templateHtml = "<div class=\"modal__inner\"> <div class=\"modal__head_toolbar container\"> <button class=\"modal__head_toolbar-close\" title=\"Close\"></button> </div> <div class=\"modal__content container\"></div> </div>";

                if (!target) {
                    return;
                }

                this.init(target);

                this.open();
            }

            init(target) {
                this.target = target;

                this.modal = document.createElement('section');
                this.modal.classList.add('modal');
                this.modal.innerHTML = this.templateHtml;

                this.modal.addEventListener('click', (e) => {
                    if (e.target !== this.modal) {
                        e.preventDefault();
                        return;
                    }

                    this.close();
                });

                const closeBtn = this.modal.querySelector('.modal__head_toolbar-close');
                if (closeBtn) {
                    closeBtn.addEventListener('click', (e) => {
                        e.preventDefault();
                        this.close();
                    });
                }

                document.body.append(this.modal);
            }

            open() {
                const contentWrapper = this.modal.querySelector('.modal__content');
                if (!contentWrapper) {
                    return;
                }

                Array.from(this.target.childNodes).forEach(el => contentWrapper.append(el));
                setTimeout(() => this.modal.classList.add('active'));

                document.documentElement.style.overflowY = 'hidden';
                // document.body.style.overflowY = 'hidden';
                window.location.hash = this.target.id;
            }

            close() {
                const contentWrapper = this.modal.querySelector('.modal__content');
                Array.from(contentWrapper.childNodes).forEach(el => this.target.append(el));

                this.modal.classList.remove('active');
                setTimeout(() => this.modal.remove(), 1000);

                document.documentElement.style.overflowY = 'inherit';
                // document.body.style.overflowY = 'inherit';
                window.history.pushState({}, '', '#');
            }
        }

        /*
         * Initialization
         */

        const activeModals = [];

        setupTriggers();
        setupEscButton();
        onURLUpdated(null, true);

        const modals = document.querySelectorAll('.modal');
        modals.forEach(blockEl => init(blockEl));

        /*
         * Functions
         */

        function init(blockEl) {
            blockEl.addEventListener('click', function (e) {
                if (e.target !== blockEl) {
                    return;
                }

                closeAll();
            });

            const closeBtn = blockEl.querySelector('.modal__head_toolbar-close');
            if (closeBtn) {
                closeBtn.addEventListener('click', function (e) {
                    closeAll();
                });
            }
        }

        function setupTriggers() {
            window.addEventListener('hashchange', onURLUpdated);
        }

        function onURLUpdated(e, scrollToElement = false) {
            const hash = window.location.hash;
            if (!hash) {
                closeAll();
                return;
            }

            const target = document.querySelector(hash);
            if (!target) {
                return;
            }

            if (scrollToElement) {
                target.parentNode.scrollIntoView({behavior: "smooth", block: "center", inline: "nearest"});
            }

            const display = window.getComputedStyle(target, null).display;
            if (display === 'none') {
                open(target);
            }
        }

        function open(target) {
            activeModals.push(new Modal(target));
        }

        function setupEscButton() {
            document.addEventListener('keydown', function (event) {
                const key = event.key; // const {key} = event; in ES6+
                if (key !== "Escape") {
                    return;
                }

                closeAll();
            });
        }

        function closeAll() {
            activeModals.forEach((modal, index) => {
                modal.close();
                delete activeModals[index];
            });
        }

    }

    function setCookie(cname, cvalue, exdays) {
        const d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        let expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    function getCookie(cname) {
        let name = cname + "=";
        let ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    function initHubspot($) {
        $.fn.notifyHubspot = function () {
            function doEvent(obj, name) {
                try {
                    const event = new Event(name, {target: obj, bubbles: true});
                    return obj ? obj.dispatchEvent(event) : false;
                } catch (e) {
                    const event = document.createEvent('Event');
                    event.initEvent(name, true, true);
                    obj.dispatchEvent(event);
                }
            }

            $(this).each(function () {
                doEvent(this, 'change');
                doEvent(this, 'input');
                doEvent(this, 'blur');
            });

            $(this).focus();
            $(this).blur();

            return $(this);
        };
    }


    function sendDataToHubspot(accountId, formId, fields) {
        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        fields = fields.map(field => {
            return Object.assign({}, field, {objectTypeId: "0-1"});
        });

        const args = {
            "fields": fields,
            "context": {
                "pageUri": window.location.href,
                "pageName": document.title
            },
        };

        const hutk = getCookie('hubspotutk');
        if (hutk) {
            args.context.hutk = hutk;
        }

        const requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: JSON.stringify(args),
            // redirect: 'follow'
        };

        return fetch(`https://api.hsforms.com/submissions/v3/integration/submit/${accountId}/${formId}`, requestOptions)
            .then(response => response.json())
            .then(result => {
                console.log(result);
                if (result.status === 'error') {
                    throw new Error(result.errors.map(error => error.message).join(', '));
                }
            });
    }

    const POPUP_ID = 872;
    const ELEMENTOR_FORM_ID = '#use_case_form_el';
    const HUBSPOT_ACCOUNT_ID = '21868768';
    const HUBSPOT_FORM_ID = 'a2d34618-80ee-4c88-9d40-6e0e1529c5b1';

    const links = {
        'automated policy management': 'https://www.velotix.ai/our-platform/automated-policy-management/',
        'data access': 'https://www.velotix.ai/our-platform/data-access/',
        'data discoverability': 'https://www.velotix.ai/our-platform/data-discoverability/'
    };

    function initUseCasesForms($) {
        $(document).on('elementor/popup/show', (event, id, instance) => {
            if (id !== POPUP_ID) {
                return;
            }

            const popup = document.getElementById('elementor-popup-modal-' + POPUP_ID);
            const form = popup.querySelector('.elementor-form');

            initForm(form);
        });

        $(document).on('submit_success', ELEMENTOR_FORM_ID, function () {

            const $inputs = $(ELEMENTOR_FORM_ID + ' :input');
            const values = [];
            $inputs.each(function () {
                let name = this.name;
                if (this.type === 'checkbox' && !this.checked) {
                    return
                }

                if (name.startsWith('form_fields[')) {
                    name = name.replace('[]', '');
                    name = name.replace('form_fields[', '');
                    name = name.substring(0, name.length - 1);
                }

                const whitelisted_fields = ['email', 'firstname', 'lastname', 'phone', 'company', 'use_case_type', 'use_cases', 'use_case_other'];
                if (whitelisted_fields.includes(name)) {
                    values.push({
                        name: name,
                        value: $(this).val(),
                    });
                }
            });

            console.log(values);
            setErrorMessage(null);

            sendDataToHubspot(HUBSPOT_ACCOUNT_ID, HUBSPOT_FORM_ID, mapFields(values))
                .then(() => {
                    document.querySelectorAll('.usecases-form-slide').forEach(slide => slide.style.display = 'none');

                    // Update Label
                    const typeLabel = document.getElementById('use_case_type-label');
                    if (typeLabel) {
                        typeLabel.innerText = getCookie('use_case_type');
                    }

                    // Update Link URL
                    const linkBtn = document.getElementById('use_case_type-btn');
                    if (linkBtn) {
                        linkBtn.querySelector('a').href = links[getCookie('use_case_type')];
                    }

                    document.querySelectorAll('.usecases-thank-you-slide').forEach(slide => slide.style.display = 'block');
                })
                .catch(error => {
                    setErrorMessage(error.message);
                });

        });

    }

    function setErrorMessage(message) {
        document.querySelectorAll('.usecases-form-error').forEach(errorEl => {
            if (message) {
                errorEl.innerText = message;
                errorEl.style.display = 'block';
            } else {
                errorEl.innerText = '';
                errorEl.style.display = 'none';
            }
        });
    }

    function mapFields(fields) {
        return fields;
    }

    function initForm(form) {
        const checkboxes = form.querySelectorAll('input[name="form_fields[use_cases][]"]');
        checkboxes.forEach(checkbox => {
            checkbox.addEventListener('change', (event) => {
                toggleOtherOption(form);

                const type = calculateUseCaseType(form);
                setCookie('use_case_type', type);
                form.querySelector('input[name="form_fields[use_case_type]"]').value = type;
            });
        });
    }

    function toggleOtherOption(form) {
        const otherField = form.querySelector('.elementor-field-group-use_case_other');
        if (!otherField) {
            return;
        }

        const otherOption = form.querySelector('input[value="Other"]');
        const showOtherField = otherOption && otherOption.checked;

        otherField.style.display = showOtherField ? 'block' : 'none';
    }


    function calculateUseCaseType(form) {
        let useCaseType = 'data discoverability'; // T1
        let breakLoop = false;

        const useCases = [{
            type: "automated policy management",
            id: "form-field-use_cases-5" // T3
        }, {
            type: "automated policy management",
            id: "form-field-use_cases-4" // T3
        }, {
            type: "data access",
            id: "form-field-use_cases-3" // T2
        }, {
            type: "data access",
            id: "form-field-use_cases-2" // T2
        }];

        const useCaseCalc = {};
        useCases.forEach(useCase => {
            if (breakLoop) {
                return;
            }

            useCaseCalc[useCase.type] = useCaseCalc[useCase.type] || 0;
            if (form.querySelector('#' + useCase.id).checked) {
                useCaseCalc[useCase.type]++;
            }

            if (useCaseCalc[useCase.type] >= 2) {
                useCaseType = useCase.type;
                breakLoop = true;
            }
        });

        return useCaseType;
    }

    function addOSClassName() {
        var os = navigator.userAgent.toLowerCase();

        if (os.indexOf('win') > -1) {
            document.body.classList.add('windows-os');
        } else if (os.indexOf('mac') > -1) {
            document.body.classList.add('mac-os');
        } else if (os.indexOf('linux') > -1) {
            document.body.classList.add('linux-os');
        }
    }

    /**
     * Global Blocks init function.
     */
    function initBlock(blockName = '', selector = '', cb) {

        if (window.acf) {
            window.acf.addAction('render_block_preview', function (el, block) {
                const acfBlockName = blockName.split(/@|\//).filter(e => !!e).join('--');
                if (block.name === 'acf/' + acfBlockName) {
                    cb(el[0]);
                }
            });
        } else {
            document.querySelectorAll(selector).forEach((el) => cb(el));
        }

    }

    window.initBlock = initBlock;

    /**
     * Custom
     */

    (function ($) {

        /**
         * Init
         */

        try {
            initForms($);
            initModals($);
            initHubspot($);

            initElementorPopups();
            initCookieBanner();
            initUseCasesForms($);
        } catch (err) {
            console.error(err);
        }

        // We should release animations even if there are errors.
        initAnimations();
        addOSClassName();

        /**
         * Functions
         */

        function initCookieBanner() {
            document.querySelectorAll('[href="#cookie-preferences"]')
                .forEach((link) => link.addEventListener('click', triggerCookiePreferences));

            function triggerCookiePreferences() {
                // Trigger Cookie Preferences.
                const _hsp = window._hsp = window._hsp || [];
                _hsp.push(['showBanner']);
            }
        }

    })(window.jQuery);

}));
